export const getFullName = (firstName: string, lastName: string) => `${lastName} ${firstName}`;
